import React, { useState } from 'react';

const ForgotPasswordForm = ({ onResetPassword, onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate sending reset link
    setMessage(`Si el correo "${email}" está registrado, se enviará un enlace de recuperación.`);
    // In a real application, you would send an actual email here.
    // onResetPassword(email); // Call the function to handle the reset logic (simulated)
    setEmail(''); // Clear the input field
  };

  return (
    <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-orange-600 to-orange-400 py-6 px-8">
        <h2 className="text-2xl font-bold text-white text-center">Recuperar Contraseña</h2>
      </div>
      <form onSubmit={handleSubmit} className="p-8 space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Correo Electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all placeholder-gray-400"
            placeholder="Ingresa tu correo electrónico"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-gradient-to-r from-orange-600 to-orange-400 text-white py-3 px-4 rounded-lg hover:from-orange-700 hover:to-orange-500 transition-all shadow-md font-semibold"
        >
          Enviar enlace de recuperación
        </button>
         {message && (
           <p className="text-sm text-center text-gray-600 mt-4">{message}</p>
         )}
         <button
            type="button"
            onClick={onBackToLogin}
            className="w-full text-center text-sm text-blue-600 hover:underline mt-4"
          >
            Volver al inicio de sesión
          </button>
      </form>
      <div className="px-8 py-4 bg-gray-50 border-t border-gray-200 text-center">
        <p className="text-xs text-gray-600">Se enviará un enlace a tu correo para restablecer la contraseña.</p>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;

// DONE